import call from './call';
import messageShow from "./messageShow";
import {clientURL} from "../url";

const checkProfile= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            if(result[1].type && result[1].type!=='client')
                window.location.href=clientURL;
        }
        else
            dispatch(messageShow({message: result[1].error, type: 'error'}));
    }
    dispatch(call("Service/checkProfile",formValues,onResult));
};
export default checkProfile;